// @ts-ignore
import content from './md/customer-communication-that-closes.md';

export const meta = {
  slug: 'customer-communication-that-closes',
  title: 'Customer Communication That Closes: SMS, Email, and In-App Messaging Best Practices',
  excerpt: 'The best home service businesses aren\'t always the most skilled—they\'re the ones that communicate best. Learn the messaging strategies that build trust and close deals.',
  date: 'January 2025',
  readTime: '10 min read',
  image: '/docs/customer-communication-that-closes/header.png'
};

export { content };
